import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Navbar from '../components/Navbar';
import './BookingList.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';

const PAGE_SIZE = 5;

const BookingList = () => {
  const [bookings, setBookings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [tracking, setTracking] = useState({
    location_name: '',
    status_note: '',
    tracking_time: new Date().toISOString().slice(0, 16)
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = () => {
    api.get('/bookings')
      .then(res => {
        const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setBookings(sorted);
      })
      .catch(err => console.error('Error fetching bookings:', err));
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this booking?')) {
      api.delete(`/bookings/${id}`)
        .then(() => fetchBookings())
        .catch(err => {
          console.error('Error deleting booking:', err);
          alert('Failed to delete booking.');
        });
    }
  };

  const handleEdit = (id) => {
    navigate(`/bookings/edit/${id}`);
  };

const indianTime = new Date().toLocaleString("en-US", {
  timeZone: "Asia/Kolkata",
  hour12: false,
});


  const openTrackingModal = (booking) => {
    setSelectedBooking(booking);
    setTracking({
      location_name: '',
      status_note: '',
      tracking_time: new Date(indianTime).toISOString().slice(0, 16)
    });
    setModalIsOpen(true);
  };

  const handleTrackingChange = (e) => {
    setTracking({ ...tracking, [e.target.name]: e.target.value });
  };

//   const handleTrackingSubmit = async (e) => {
//     e.preventDefault();
//     try {
//         await api.post(`/tracking/${selectedBooking.id}`, {
//             bookingId: selectedBooking.id,  ...tracking
// });    
//       alert('Tracking updated successfully');
//       setModalIsOpen(false);
//     } catch (err) {
//       console.error('Tracking update error:', err);
//       alert('Failed to update tracking');
//     }
//   };
const handleTrackingSubmit = async (e) => {
  e.preventDefault();
  try {
    const formData = new FormData();
    formData.append("bookingId", selectedBooking.id);
    formData.append("location_name", tracking.location_name);
    formData.append("status_note", tracking.status_note);
    formData.append("tracking_time", tracking.tracking_time);

    if (tracking.delivery_image) {
      formData.append("delivery_image", tracking.delivery_image);
    }

    await api.post(`/tracking/${selectedBooking.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    alert("Tracking updated successfully");
    setModalIsOpen(false);
  } catch (err) {
    console.error("Tracking update error:", err);
    alert("Failed to update tracking");
  }
};


  const filteredBookings = bookings.filter(b =>
    b.awbnumber?.toLowerCase().includes(search.toLowerCase()) ||
    b.status?.toLowerCase().includes(search.toLowerCase()) ||
    b.customername?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredBookings.length / PAGE_SIZE);
  const paginatedBookings = filteredBookings.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  return (
    <>
      <Navbar />
      <div className="booking-container">
        <div className="booking-header">
          <h2>Booking List</h2>
          <button className="add-btn" onClick={() => navigate('/bookings/new')}>
            + Add Booking
          </button>
        </div>

        <div className="search-bar">
          <input
            type="text"
            placeholder="Search by AWB, Status, Customer..."
            value={search}
            onChange={e => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="table-responsive">
          <table className="booking-table">
            <thead>
              <tr>
                <th>#</th>
                <th>AWB Number</th>
                <th>Status</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Customer</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedBookings.map((b, index) => (
                <tr key={b.id}>
                  <td>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                  <td>{b.awbnumber}</td>
                  <td>{b.status}</td>
                  <td>{b.pickup_city || 'N/A'}</td>
                  <td>{b.delivery_city || 'N/A'}</td>
                  <td>{b.customername || 'N/A'}</td>
                  <td>{new Date(b.createdAt).toLocaleString()}</td>
                  <td className="action-icons">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="icon track-icon" title="Update Tracking" onClick={() => openTrackingModal(b)} />
                    <FontAwesomeIcon icon={faEdit} className="icon edit-icon" title="Edit" onClick={() => handleEdit(b.id)} />
                    <FontAwesomeIcon icon={faTrash} className="icon delete-icon" title="Delete" onClick={() => handleDelete(b.id)} />
                  </td>
                </tr>
              ))}
              {filteredBookings.length === 0 && (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', padding: '10px' }}>
                    No bookings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>Previous</button>
            <span>Page {currentPage} of {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>Next</button>
          </div>
        )}
      </div>

      {/* Tracking Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Tracking Update"
        className="tracking-modal"
        overlayClassName="tracking-overlay"
        ariaHideApp={false}
      >
        <h3>Update Tracking - {selectedBooking?.awbnumber}</h3>
        {/* <form onSubmit={handleTrackingSubmit} className="tracking-form">
          <label>Location Name</label>
          <input
            type="text"
            name="location_name"
            value={tracking.location_name}
            onChange={handleTrackingChange}
            required
          />

          <label>Status Note</label>
          <textarea
            name="status_note"
            rows="3"
            value={tracking.status_note}
            onChange={handleTrackingChange}
            required
          />

          <label>Tracking Time</label>
          <input
            type="datetime-local"
            name="tracking_time"
            value={tracking.tracking_time}
            onChange={handleTrackingChange}
          />

          <div className="modal-actions">
            <button type="submit">Submit</button>
            <button type="button" className="cancel-btn" onClick={() => setModalIsOpen(false)}>Cancel</button>
          </div>
        </form> */}
        <form onSubmit={handleTrackingSubmit} className="tracking-form">
  <label>Next Destination Name</label>
  <input
    type="text"
    name="location_name"
    value={tracking.location_name}
    onChange={handleTrackingChange}
    required
  />

  <label>Status</label>
  <select
    name="status_note"
    value={tracking.status_note}
    onChange={handleTrackingChange}
    required
  >
    <option value="">-- Select Status --</option>
    <option value="Booking Confirm">Booking Confirm</option>
    <option value="In Transit">In Transit</option>
     <option value="Out For Delivery">Out For Delivery</option>
    <option value="Delivered">Delivered</option>
    <option value="Re-attempt">Re-attempt</option>
    <option value="Return to Origin">Return to Origin</option>
    <option value="Not Available at Destination">Not Available at Destination</option>
    <option value="Discard">Discard</option>
  </select>

  {tracking.status_note === "Delivered" && (
    <>
      <label>Proof of Delivery (Image)</label>
      <input
        type="file"
        name="delivery_image"
        accept="image/*"
        onChange={(e) =>
          setTracking({ ...tracking, delivery_image: e.target.files[0] })
        }
        required
      />
    </>
  )}

  <label>Tracking Time</label>
  <input
    type="datetime-local"
    name="tracking_time"
    value={tracking.tracking_time}
    onChange={handleTrackingChange}
  />

  <div className="modal-actions">
    <button type="submit">Submit</button>
    <button
      type="button"
      className="cancel-btn"
      onClick={() => setModalIsOpen(false)}
    >
      Cancel
    </button>
  </div>
</form>

      </Modal>
    </>
  );
};

export default BookingList;
